import StencilHTMLElement from "./stencil-element";

class ShopifyRecommendations extends StencilHTMLElement {
  url; 
  constructor() {
    super();
  }

  connectedCallback() {
    this.url = this.getAttribute('url');
    if (!this.url) {
      console.error(this.logPrefix, 'Missing data-url attribute');
      return;
    }
    this.init();
  }

  init() {
    const productRecommendationsSection = this.firstElementChild;

    // In Theme Editor, load immediately so preview shows without scrolling
    if (typeof window.Shopify !== 'undefined' && window.Shopify['designMode']) {
      // If not on a product page in the editor, skip fetching and keep server-rendered defaults
      if (!(document.querySelector('.template-product'))) {
        return;
      }
      if (productRecommendationsSection) {
        this.fetchRecommendations(productRecommendationsSection);
      }
      return;
    }

    const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    });

    if (productRecommendationsSection) {
      observer.observe(productRecommendationsSection);
    }
  }

  handleIntersection(entries, observer) {
    const productRecommendationsSection = this.firstElementChild;

    if (!entries[0].isIntersecting || !productRecommendationsSection) return;

    observer.unobserve(productRecommendationsSection);

    this.fetchRecommendations(productRecommendationsSection);
  }

  async fetchRecommendations(productRecommendationsSection) {
    try {
      const response = await fetch(this.url);
      if (!response.ok) {
        // In editor or if endpoint is unavailable, keep existing server markup
        return;
      }
      const text = await response.text();
      
      const recommendations = new DOMParser().parseFromString(text, 'text/html')?.querySelector("[data-outer]");
  
      if (recommendations) {
        recommendations.querySelectorAll("script:not([type='application/json'])").forEach(element => {
          (0, eval)(element.textContent || "");
          element.remove();
        });
  
        if (recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
    
        document.querySelectorAll("script[id^='offcanvas-injection']").forEach(e => {
          (0, eval)(e.textContent || "");
        });
  
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      }
    } catch (e) {
      console.error('Fetch error:', e);
    }
  }
}

export default ShopifyRecommendations;
